/* src/app/edge/live/energymonitor/flow/energymonitor-flow.component.scss */
.flow-widget {
  position: relative;
  width: 100%;
  max-width: 420px;
  aspect-ratio: 1;
  margin: 12px auto;
}
.flow-links {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
}
.flow-line {
  fill: none;
  stroke: var(--ion-color-medium);
  stroke-width: 3;
  stroke-linecap: round;
  opacity: 0.22;
  transition: opacity 0.3s ease, stroke 0.3s ease;
}
.flow-line.is-active {
  opacity: 0.55;
}
.flow-dot {
  fill: var(--node-color, var(--ion-color-medium));
  filter: drop-shadow(0 0 4px var(--node-color, transparent));
  animation-name: energymonitor-flow-move;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
.flow-dot.reverse {
  animation-direction: reverse;
}
@keyframes energymonitor-flow-move {
  from {
    offset-distance: 0%;
  }
  to {
    offset-distance: 100%;
  }
}
.flow-node {
  position: absolute;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-sizing: border-box;
  padding: 4%;
  text-align: center;
  background: var(--ion-item-background);
  border: 2px solid var(--ion-color-medium-soft, var(--ion-color-medium));
  color: var(--ion-text-color);
  opacity: 0.55;
  transition:
    opacity 0.3s ease,
    border-color 0.3s ease,
    box-shadow 0.3s ease;
}
.flow-node ion-icon {
  font-size: 20px;
  color: var(--node-color, var(--ion-color-medium));
  margin-bottom: 2px;
}
.flow-node .flow-value {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.15;
  white-space: nowrap;
}
.flow-node .flow-subtext {
  font-size: 10px;
  opacity: 0.75;
  line-height: 1.15;
}
.flow-node .flow-label {
  font-size: 8px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  opacity: 0.65;
  margin-top: 1px;
}
.flow-node.is-active {
  opacity: 1;
  border-color: var(--node-color, var(--ion-color-medium));
  box-shadow: 0 0 16px -3px var(--node-color, transparent);
}
.flow-node.accent-production {
  --node-color: var(--ion-color-production);
}
.flow-node.accent-grid {
  --node-color: var(--ion-color-dark);
}
.flow-node.accent-storage {
  --node-color: var(--ion-color-success);
}
.flow-node.hub {
  --node-color: var(--ion-color-warning);
  border-width: 3px;
  cursor: pointer;
}
.flow-node.hub ion-icon {
  font-size: 28px;
}
.flow-node.hub .flow-value {
  font-size: 15px;
}
.flow-node.hub:hover,
.flow-node.hub:focus-visible {
  box-shadow: 0 0 20px -2px var(--node-color);
  transform: translate(-50%, -50%) scale(1.04);
}
.flow-node.hub:focus-visible {
  outline: 2px solid var(--node-color);
  outline-offset: 2px;
}
.flow-line.accent-production.is-active {
  stroke: var(--ion-color-production);
}
.flow-line.accent-grid.is-active {
  stroke: var(--ion-color-dark);
}
.flow-line.accent-storage.is-active {
  stroke: var(--ion-color-success);
}
.flow-dot.accent-production {
  --node-color: var(--ion-color-production);
}
.flow-dot.accent-grid {
  --node-color: var(--ion-color-dark);
}
.flow-dot.accent-storage {
  --node-color: var(--ion-color-success);
}
/*# sourceMappingURL=energymonitor-flow.component.css.map */
